module.exports = __webpack_public_path__ + "static/media/gcdef_10021.364a6a7e.ico";